import { IndexedArray } from '@common/types';

export const generateBaseFieldsNamesOptionsFromEnums = (data?: IndexedArray<any> | null) => {
  return Object.entries(data ?? {}).map(([value, label]) => {
    return { value, label };
  });
};
